/**
 * F-recettes-encaissees Fase B — estimativa do IS (impôt sur les sociétés) FR.
 *
 * Regra 2026 (PME elegível — CA < 10 M€, capital integralizado, ≥75% pessoas
 * físicas, perfil Euro Storm): 15% até 42 500 € de resultado fiscal, 25% acima.
 * É ESTIMATIVA sobre o resultado ANTES dos retraitements fiscais (2058-A:
 * reintegrações/deduções do contador) — informa, não declara.
 */

export const IS_REDUCED_CAP = 42_500;
export const IS_REDUCED_RATE = 0.15;
export const IS_NORMAL_RATE = 0.25;

export interface IsEstimate {
  /** Fatia do resultado tributada a 15% (0..42 500). */
  base15: number;
  /** Fatia do resultado tributada a 25% (acima de 42 500). */
  base25: number;
  is15: number;
  is25: number;
  /** IS total estimado (0 quando resultado ≤ 0). */
  total: number;
  /** Resultado − IS estimado (igual ao resultado quando há prejuízo). */
  netAfterIs: number;
}

export function estimateIS(resultat: number): IsEstimate {
  const r = Number.isFinite(resultat) ? resultat : 0;
  if (r <= 0) {
    return { base15: 0, base25: 0, is15: 0, is25: 0, total: 0, netAfterIs: r };
  }
  const base15 = Math.min(r, IS_REDUCED_CAP);
  const base25 = Math.max(0, r - IS_REDUCED_CAP);
  const is15 = Math.round(base15 * IS_REDUCED_RATE * 100) / 100;
  const is25 = Math.round(base25 * IS_NORMAL_RATE * 100) / 100;
  const total = Math.round((is15 + is25) * 100) / 100;
  return { base15, base25, is15, is25, total, netAfterIs: Math.round((r - total) * 100) / 100 };
}
